<template>
	<div class="order-details-page" v-loading="isLoading">
		<template v-if="orderDetailsList.order && orderDetailsList.order.id">
			<div class="status-box">
				<div class="header-line">
					<div class="header-line-left">
						<span>下单时间：{{ orderDetailsList.order.createTime }}</span>
						<span>支付时间：{{ orderDetailsList.paymentInfo.payTime ? orderDetailsList.paymentInfo.payTime : '-' }}</span>
						<span>记账时间：{{ orderDetailsList.order.deliveryTime ? orderDetailsList.order.deliveryTime : '-' }}</span>
					</div>
					<div class="header-line-right">
						<span>订单编号：{{ orderDetailsList.order.orderSn }}</span>
					</div>
				</div>
				<div class="status-content">
					<div class="left-box" v-if="orderDetailsList.order.status =='301' || orderDetailsList.order.status == '501'">
						<div class="logistics-box"
							v-if="orderDetailsList.order.status == '301' || orderDetailsList.order.status == '501'">
							<div class="logistics-scroll-x" v-if="logistics.length > 1">
								<div class="logistics-single" v-for="(item, index) in logistics" :key="index"
									@click="handleLogistics(index, item)" :class="{ select: selectIndex == index }">
									包裹{{index + 1}}
									<!-- <div class="iconfont icon-duihao"></div> -->
									<i class="el-icon-check icon"></i>
								</div>
							</div>
							<div class="logistics-right">
								<span class="logistics-right-text">{{logisticsObj.deliveryCompany}}</span>
								<span class="logistics-right-num">{{logisticsObj.deliverySn}}</span>
								<span class="iconfont icon-fuzhi" @click="handleCopy(logisticsObj.deliverySn)"></span>
							</div>
						</div>
						<div class="logistics-info-box"
							v-if="!showAllLogistics && (orderDetailsList.order.status == '301' || orderDetailsList.order.status == '501')">
							<template v-if="logisticsObj.pickType == 'DELIVERY'">
								<div class="info-left">
									<div class="left-icon">
										<div class="iconfont icon-shangpinfahuo"></div>
									</div>
									<div class="left-text">
										<div class="left-text-line">{{ filtersAction(selectedLogisticsObj.Action) }}</div>
										<div class="left-text-subline">{{ selectedLogisticsObj.AcceptStation }}</div>
									</div>
								</div>
								<div class="info-right" @click="showAllLogistics = true">展开物流信息</div>
							</template>
							<template v-if="logisticsObj.pickType == 'SELF'">
								<div class="info-left-self">商家自配</div>
							</template>
						</div>
						<div class="logistics-info-box" v-if="showAllLogistics">
							<div class="info-left" v-for="(traces, index) in tracesArrReverse" :key="index">
								<div class="left-icon">
									<div class="iconfont icon-shangpinfahuo"></div>
								</div>
								<div class="left-text">
									<div class="left-text-line">{{ filtersAction(traces.Action) }}</div>
									<div class="left-text-subline">{{ traces.AcceptStation }}</div>
								</div>
							</div>
							<div class="info-right" @click="showAllLogistics = false">收起物流信息</div>
						</div>
					</div>
					<div class="right-box"
						:style="{ 'width': orderDetailsList.order.status =='301' || orderDetailsList.order.status == '501' ? '458px' : '1198px' }">
						<div class="status-text" v-if="orderDetailsList.order.status == '000'">
							<span class="iconfont icon-a-daifukuandaifahuo"></span>
							<span>待付款</span>
						</div>
						<div class="status-text" v-if="orderDetailsList.order.status == '101'">
							<span class="iconfont icon-a-daifukuandaifahuo"></span>
							<span>待发货</span>
						</div>
						<div class="status-text" v-if="orderDetailsList.order.status == '301'">
							<span class="iconfont icon-yifahuo"></span>
							<span>已发货</span>
						</div>
						<div class="status-text" v-if="orderDetailsList.order.status == '501'">
							<span class="iconfont icon-yishouhuo"></span>
							<span>已收货</span>
						</div>
						<div class="status-text" v-if="orderDetailsList.order.status == '601'">
							<span class="iconfont icon-yiquxiao"></span>
							<span>交易关闭</span>
						</div>
						<div class="status-text" v-if="orderDetailsList.order.status == '701'">
							<span class="iconfont icon-yiquxiao"></span>
							<span>已取消</span>
						</div>
						<div class="status-subtext" v-if="orderDetailsList.order.status == '000'">
							<span
								v-if="orderDetailsList.arrearsAmount && orderDetailsList.order.payType == 'PAYMENT'">余额不足，请充值￥{{ orderDetailsList.arrearsAmount }}，</span>
							<span
								v-else-if="orderDetailsList.arrearsAmount && orderDetailsList.order.payType == 'CREDIT'">授信额度不足，</span>
							{{ getPayCountDown(orderDetailsList.order) }}
						</div>
						<div class="status-subtext" v-if="orderDetailsList.order.status == '101'">我们会尽快安排发货</div>
						<div class="status-subtext" v-if="orderDetailsList.order.status == '301'">您的商品已经发货</div>
						<div class="status-subtext" v-if="orderDetailsList.order.status == '501'">您已确认收到商品</div>
						<div class="status-subtext" v-if="orderDetailsList.order.status == '601'">您已确认收到商品</div>
						<div class="status-subtext" v-if="orderDetailsList.order.status == '701'">已关闭本次订单</div>

						<div class="btn-box">
							<template v-if="orderDetailsList.order.status == '000' || orderDetailsList.order.status == '301'">
								<el-button type="primary" v-if="orderDetailsList.order.status == '000'"
									@click="doPay(orderDetailsList.order.id);">付款</el-button>
								<el-button type="primary" v-else-if="orderDetailsList.order.status == '301'"
									@click="confirmReceipt(orderDetailsList.order.id);">确认收货</el-button>
							</template>
							<el-button type="info" plain v-if="orderDetailsList.order.status == '000'"
								@click="cancelOrder(orderDetailsList.order.id);">取消订单</el-button>
							<el-button type="info" plain v-else @click="againOrder(orderDetailsList.order.id);">再来一单</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="adress-box">
				<div class="adress-left-box">
					<div class="adress-line">
						<div class="line-left">收件人：</div>
						<div class="line-right">{{ orderDetailsList.address.name }}</div>
					</div>
					<div class="adress-line">
						<div class="line-left">手机号：</div>
						<div class="line-right">{{ orderDetailsList.address.phone }}</div>
					</div>
					<div class="adress-line">
						<div class="line-left">收货地址：</div>
						<div class="line-right">{{ orderDetailsList.address.allAddress }}</div>
					</div>
					<div class="adress-line" v-if="orderDetailsList.order && orderDetailsList.order.remark">
						<div class="line-left">备注：</div>
						<div class="line-right">{{ orderDetailsList.order.remark }}</div>
					</div>
				</div>
				<div class="adress-right-box">
					<div class="right-line">
						<!-- <div class="line-text">商品合计</div> -->
						<div class="line-text">商品总额：</div>
						<div class="line-num">￥{{ orderDetailsList.order.totalAmount }}</div>
					</div>
					<div class="right-line">
						<div class="line-text">邮寄费：</div>
						<div class="line-num">￥{{ orderDetailsList.order.sendAmount }}</div>
					</div>
					<div class="right-line">
						<div class="line-text">优惠券</div>
						<div class="line-num">-￥{{ orderDetailsList.order.couponAmount }}</div>
					</div>
<!-- 					<div class="right-line">
						<div class="line-text">满减金额：</div>
						<div class="line-num">-￥{{ orderDetailsList.order.discountAmount }}</div>
					</div> -->

					<div class="right-line">
						<div class="line-text">优惠合计：</div>
						<div class="line-num">-￥{{ orderDetailsList.totalDiscount }}</div>
					</div>
					<div class="amount-box">
						<div class="right-line">
							<div class="line-text">应付总额：</div>
							<div class="line-num">￥{{ orderDetailsList.order.userAmount }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="table-box" v-if="orderDetailsList.details && orderDetailsList.details.length > 0">
				<div class="table-header">
					<div class="tab1">商品信息
	<!-- 					<div class="download-text">
							<div class="iconfont icon-xiazai"></div>
							<div class="val-down2" @click="handleDownloadZjd(item.productTypeCode, item.productName);">下载电子质检单</div>
						</div> -->
					</div>
					<div class="tab2">单价</div>
					<div class="tab3">数量</div>
					<div class="tab4">小计</div>
				</div>
				<div class="table-content">
					<div class="tr-box" v-for="(item, index) in orderDetailsList.details" :key="item.id">
						<div class="tr-content">
							<div class="tab1">
								<div class="img-box"><img :src="item.pic" /></div>
								<div class="tab1-right">
									<div class="name">{{ item.productName }}</div>
									<div class="msg">
										<div class="val val-style">规<span :style="{'marginRight': '28px'}"></span>格：{{ item.spec }}</div>
									</div>
									<div class="msg">
										<div class="val val-style">编<span :style="{'marginRight': '28px'}"></span>码：{{ item.productTypeCode ? item.productTypeCode : '-'}}</div>
									</div>
									<div class="msg">
										<div class="val val-style-no-left">厂<span :style="{'marginRight': '28px'}"></span>商：{{ item.manufacturers ? item.manufacturers : '-'}}</div>
									</div>
									<div class="msg">
										<div class="val val-style-no-left">出库数量：{{ item.deliveryQuantity ? item.deliveryQuantity : '-'}}</div>
									</div>
									<div class="msg">
										<div class="val val-style-no-left">出库金额：{{ item.deliveryAmount ? item.deliveryAmount : '-'}}</div>
									</div>
									<div class="msg">
										<div class="val val-style-no-left">记账日期：{{ item.deliveryTime ? item.deliveryTime : '-'}}</div>
									</div>
									<div class="msg" v-if="orderDetailsList.order && orderDetailsList.order.separateWarehouseCode == '9000'">
										<div class="iconfont icon-xiazai"></div>
										<div class="val-down" @click="handleDownload(item.productTypeCode, item.productName);">首营资料下载</div>
									</div>
								</div>
							</div>
							<div class="tab2">
								<div class="price">￥{{ formatNum(item.price) }}</div>
								<div class="underline-price" v-if="item.price !== item.originPrice">￥{{ formatNum(item.originPrice) }}</div>
							</div>
							<div class="tab3">
								<div class="price">×{{ item.quantity }}（{{ item.mseh3 ? item.mseh3 : '盒'}}）</div>
							</div>
							<div class="tab4">
								<div class="price">
									￥{{ item.quantity && item.quantity != '0' && item.quantity > 0 ? formatNum(parseFloat(item.price) * item.quantity) : formatNum(item.price) }}
								</div>
							</div>
						</div>
						<div class="gift-box" v-if="item.giftDetail && item.giftDetail.length > 0"
							v-for="(giftItem, index) in item.giftDetail" :key="index">
							<div class="tag">【赠】</div>
							<div class="img-box"><img :src="giftItem.pic" /></div>
							<div class="product-msg">
								<div class="name">
									<div class="left">{{ giftItem.productName }}</div>
									<div class="right">×{{ giftItem.quantity }}</div>
								</div>
								<div class="msg">
									<div class="label">规</div>
									<div class="val">{{ giftItem.spec }}</div>
								</div>
								<div class="msg">
									<div class="label">厂</div>
									<div class="val">{{ giftItem.manufacturers }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<el-empty v-else description="暂无数据"></el-empty>

		<!-- 支付成功弹窗 -->
		<div v-if="dialogVisibleSucess">
			<successPop :sucessPopShow="dialogVisibleSucess" :userAmount="parseFloat(orderDetailsList.order.userAmount)"
				@handleLimit="handleLimit" @handleSucessShow="handleLimit">
			</successPop>
		</div>

		<!-- 支付失败弹窗 -->
		<div v-if="dialogVisible">
			<el-dialog title="提示" :visible.sync="dialogVisible" width="400px" :before-close="handleLimitWarning">
				<div class="warning-box">
					<div class="warning-list">
						<div class="li">
							当前{{orderDetailsList.order.payType == 'PAYMENT' ? '余额' :'授信额度'}}不足
						</div>
						<template v-if="orderDetailsList.order.payType == 'PAYMENT'">
							<div class="li" v-if="payInfo.balance">
								当前余额： ￥{{parseFloat(payInfo.balance)}}
							</div>
							<div class="li" v-if="payInfo.userAmount">
								支付金额： ￥{{parseFloat(payInfo.userAmount)}}
							</div>
							<div class="li" v-if="payInfo.balance && payInfo.userAmount">
								请再充值： ￥{{Math.abs(payInfo.balance - payInfo.userAmount)}} 订单72小时有效
							</div>
						</template>
						<template v-if="orderDetailsList.order.payType == 'CREDIT'">
							订单72小时有效
						</template>
					</div>
					<div class="btn" @click="handleLimitWarning">
						确认
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		getOrderDetails,
		getLogistics,
		cancelOrder,
		doPayOrder,
		confirmReceipt,
		againOrder,
		downloadZip
	} from '@/api/order.js';
	import {
		formatNum
	} from '@/utils';
	import successPop from '@/components/successPop'

	export default {
		name: 'order-details',
		components: {
			successPop
		},
		data() {
			return {
				isLoading: false,
				orderDetailsList: {},
				selectIndex: 0,
				showAllLogistics: false,
				logistics: [], // 物流动态
				logisticsObj: {},
				tracesArrReverse: [], // 物流信息数据 数组反转
				isGetLogistics: true, // 是否获取物流信息接口
				selectedLogisticsObj: {},
				dialogVisibleSucess: false, // 是否显示支付成功弹窗
				dialogVisible: false, // 是否显示支付成功弹窗
				payInfo: '', //支付的金额明细
			};
		},
		beforeMount() {
			this.isLoading = true;
			this.getOrderDetails(this.$route.query.orderId);
		},
		methods: {
			// base64转换二进制
			base64ToArrayBuffer(base64) {
				var binaryString = window.atob(base64)
				var binaryLen = binaryString.length
				var bytes = new Uint8Array(binaryLen)
				for (var i = 0; i < binaryLen; i++) {
					var ascii = binaryString.charCodeAt(i)
					bytes[i] = ascii
				}
				return bytes
			},
			// 首营资料下载	
			handleDownload(productTypeCode, name) {
				this.isLoading = true;
				downloadZip({
					productTypeCode
				}).then(res => {
					this.isLoading = false;
					if (res && res.code == '0') {
						let base = res.data;
						let byte = this.base64ToArrayBuffer(base);
						let blob = new Blob([byte], {
							type: "application/zip",
						});
						let link = document.createElement("a");
						let href = window.URL.createObjectURL(blob); // 创建下载的链接
						link.href = href;
						link.download = name + "_首营资料.zip"; // 下载后文件名
						document.body.appendChild(link);
						link.click(); // 点击下载
						document.body.removeChild(link); // 下载完成移除元素
						window.URL.revokeObjectURL(href); // 释放掉blob对象
					} else {
						if (res && res.msg) {
							this.$message.error(res.msg);
						}
					}

				});
			},
			// 支付成功关闭弹窗刷新接口
			handleLimit() {
				this.dialogVisibleSucess = false;
				this.getOrderDetails(this.$route.query.orderId);
			},
			// 支付失败关闭弹窗
			handleLimitWarning() {
				this.dialogVisible = false;
			},
			handleCopy(data) {
				let url = data;
				let oInput = document.createElement('input');
				oInput.value = url;
				document.body.appendChild(oInput);
				oInput.select(); // 选择对象;
				document.execCommand("Copy"); // 执行浏览器复制命令
				this.$message({
					message: '复制成功',
					type: 'success'
				});
				oInput.remove()

			},
			formatNum(num) {
				if (num) {
					return formatNum(num);
				}
				return '';
			},
			/**
			 * 2023-02-09 董浩
			 * 获取状态
			 * */
			getPayCountDown(item) {
				let date = (72 * 3600 * 1000) - (new Date().getTime() - new Date(item.createTime).getTime());

				if (date <= 0) {
					return '';
				}

				let leave1 = date % (24 * 3600 * 1000);
				let hours = Math.floor(date / (3600 * 1000));

				//计算相差分钟数
				let leave2 = leave1 % (3600 * 1000);
				let minutes = Math.floor(leave2 / (60 * 1000));

				if (hours > 0) {
					return '剩' + hours + '小时' + minutes + '分钟';
				} else if (minutes > 0) {
					return '剩' + minutes + '分钟';
				} else {
					return '';
				}
			},
			getOrderDetails(orderId) {
				getOrderDetails({
					orderId
				}).then(res => {
					this.isLoading = false;
					if (res && res.code == '0') {
						this.orderDetailsList = res.data;

						if (JSON.stringify(this.orderDetailsList.address) != '{}') {
							let allAddress = '';
							allAddress = this.orderDetailsList.address.provice + this.orderDetailsList.address.city + this
								.orderDetailsList.address.district + this.orderDetailsList.address.address;
							this.$set(this.orderDetailsList.address, 'allAddress', allAddress)
						}

						// status string类型 000->待付款  101->待发货 301->已发货 501->已完成(已收货) 601->交易关闭 701->已取消
						if (JSON.stringify(this.orderDetailsList.order) != '{}' && this.orderDetailsList.order.id && this
							.isGetLogistics && (this.orderDetailsList.order.status == '301' || this.orderDetailsList.order
								.status == '501')) {
							this.getLogistics(orderId); // 获取订单物流信息
						}
					}
				});
			},
			/*
			 *2023-02-14 刘美玉
			 * 根据订单单号获取订单物流信息
			 */
			getLogistics(orderId) {
				getLogistics({
					orderId
				}).then(result => {
					this.isLoading = false;
					if (result && result.code == '0' && result.data) {
						this.logistics = result.data;
						this.logisticsObj = this.logistics[this.selectIndex];
						if (this.logisticsObj.pickType == 'DELIVERY') {
							if (this.logisticsObj.traces && JSON.parse(this.logisticsObj.traces).length > 0) {
								this.tracesArr = JSON.parse(this.logisticsObj.traces);
								this.selectedLogisticsObj = this.tracesArr[this.tracesArr.length - 1];
								this.tracesArrReverse = this.tracesArr.reverse(); // 物流信息数据 数组反转
							}
						}
					} else {
						if (result && result.msg) {
							this.$message.error(result.msg);
						}
					}
				});
			},
			handleLogisticsInfo() {
				this.showAllLogistics = true;
			},
			/*
			 *2023-02-14 刘美玉
			 * 切换包裹点击事件
			 */
			handleLogistics(index, data) {
				this.selectIndex = index;
				this.logisticsObj = data;
				this.logisticsObj = this.logistics[this.selectIndex];
				if (this.logisticsObj.pickType == 'DELIVERY') {
					if (this.logisticsObj.traces && JSON.parse(this.logisticsObj.traces).length > 0) {
						this.tracesArr = JSON.parse(this.logisticsObj.traces);
						this.selectedLogisticsObj = this.tracesArr[this.tracesArr.length - 1];
						this.tracesArrReverse = this.tracesArr.reverse(); // 物流信息数据 数组反转
					}
				}
			},
			filtersAction(action) {
				if (action == '0') {
					return '暂无轨迹信息';
				} else if (action == '1') {
					return '已揽收';
				} else if (action === '2') {
					return '在途中';
				} else if (action === '201') {
					return '到达派件城市';
				} else if (action === '202') {
					return '派件中';
				} else if (action === '211') {
					return '已放入快递柜或驿站';
				} else if (action === '3') {
					return '已签收';
				} else if (action === '301') {
					return '正常签收';
				} else if (action === '302') {
					return '派件异常后最终签收';
				} else if (action === '304') {
					return '代收签收';
				} else if (action === '311') {
					return '快递柜或驿站签收';
				} else if (action === '4') {
					return '问题件';
				} else if (action === '401') {
					return '发货无信息';
				} else if (action === '402') {
					return '超时未签收';
				} else if (action === '403') {
					return '超时未更新';
				} else if (action === '404') {
					return '拒收(退件)';
				} else if (action === '405') {
					return '派件异常';
				} else if (action === '406') {
					return '退货签收';
				} else if (action === '407') {
					return '退货未签收';
				} else if (action === '412') {
					return '快递柜或驿站超时未取';
				} else {
					return '';
				}
			},
			/**
			 * 2023-02-09 董浩
			 * 确认收货
			 * */
			confirmReceipt(id) {
				this.$confirm('是否已收到货品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.isLoading = true;
					confirmReceipt({
						orderId: id
					}).then(res => {
						if (res && res.code == '0') {
							this.getOrderDetails(this.$route.query.orderId);
							this.$message.success('已成功确认收货');
						} else {
							this.isLoading = false;
							this.$message.error(res && res.msg ? res.msg : '失败');
						}
					});
				});
			},

			/**
			 * 2023-02-09 董浩
			 * 付款
			 * */
			doPay(id) {
				this.isLoading = true;
				doPayOrder({
					orderId: id
				}).then(res => {
					if (res && res.code == '0') {
						this.dialogVisibleSucess = true;
						this.getOrderDetails(this.$route.query.orderId);
					} else {
						this.isLoading = false;
						if (res.data) {
							this.payInfo = res.data;
							this.dialogVisible = true;
						} else {
							this.$message.error(res && res.msg ? res.msg : '失败');
						}
					}
				});
			},

			/**
			 * 2023-02-09 董浩
			 * 再来一单
			 * */
			againOrder(id) {
				this.isLoading = true;
				againOrder({
					orderId: id
				}).then(res => {
					this.isLoading = false;

					if (res && res.code == '0') {
						this.$confirm('已添加购物车，是否前往下单？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$router.push('/cart');
						});
					} else {
						this.$message.error(res && res.msg ? res.msg : '取消失败');
					}
				});
			},

			/**
			 * 2023-02-09 董浩
			 * 取消订单
			 * */
			cancelOrder(id) {
				this.$confirm('确认取消订单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.isLoading = true;
					cancelOrder({
						orderId: id
					}).then(res => {
						if (res && res.code == '0') {
							this.getOrderDetails(this.$route.query.orderId);
							this.$message.success('取消成功');
						} else {
							this.isLoading = false;
							this.$message.error(res && res.msg ? res.msg : '取消失败');
						}
					});
				});
			},
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.order-details-page {
		.table-box {
			margin-top: 10px;
			display: flex;
			flex-direction: column;
			background-color: #FFFFFF;
			border-radius: 8px;

			.table-header {
				display: flex;
				align-items: center;
				color: #262728;
				padding: 20px;
				border-bottom: 1px dashed #EDEFF2;
			}

			.download-text {
				margin-left: 12px;
				display: flex;
				align-items: center;

				.icon-xiazai {
					color: #005EB1;
					cursor: pointer;
					font-size: 15px;
					line-height: 1;
				}

				.val-down2 {
					font-size: 14px;
					text-decoration: underline;
					color: #005EB1;
					margin-left: 8px;
					cursor: pointer;
				}
			}

			.table-content {
				background-color: #FFFFFF;

				.tr-box:first-child {
					border-top: none;
				}

				.tr-box {
					padding: 20px;
					border-top: 1px dashed #EDEFF2;

					.tr-content {
						display: flex;
						align-items: flex-start;

						.img-box {
							display: flex;
							justify-content: center;
							align-items: center;
							width: 100px;
							height: 100px;
							background: #FFFFFF;
							border: 1px solid #EDEFF2;
							border-radius: 10px;
							overflow: hidden;

							img {
								width: 100%;
							}
						}

						.tab3 {
							font-size: 16px;
						}
					}
				}
			}

			.tab1 {
				display: flex;
				justify-content: flex-start;
				width: 540px;
				font-size: 14px;

				.tab1-right {
					margin-left: 20px;

					.name {
						font-size: 16px;
						color: $fontColor;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						width: 400px;
					}

					.msg {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						margin-top: 10px;

						.label {
							flex-shrink: 0;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 20px;
							height: 20px;
							background: #FFFFFF;
							border: 1px solid #C0C4CC;
							border-radius: 5px;
							font-size: 13px;
							font-weight: 400;
							color: #909399;
						}

						.icon-xiazai {
							color: #C0C4CC;
							cursor: pointer;
							font-size: 15px;
							line-height: 1;
						}

						.val {
							margin-left: 4px;
							line-height: 1.2;
							font-size: 14px;
							font-weight: 400;
							color: #909399;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							width: 400px;
						}

						.val-style {
							margin-left: 0 !important;
							width: 200px !important;
						}
						.val-style-no-left {
							margin-left: 0 !important;
						}

						.val-down {
							font-size: 14px;
							text-decoration: underline;
							color: #005EB1;
							margin-left: 8px;
							cursor: pointer;
						}
					}
				}
			}

			.gift-box {
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
				margin-top: 10px;
				padding: 10px 14px 12px 7px;
				width: 610px;
				height: 103px;
				background: #F8F8F8;
				border-radius: 8px;

				.tag {
					flex-shrink: 0;
					padding-top: 20px;
					font-size: 14px;
					font-weight: 400;
					color: #F07463;
				}

				.img-box {
					flex-shrink: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 60px;
					height: 60px;
					background: #FFFFFF;
					border: 1px solid #EDEFF2;
					border-radius: 8px;
					overflow: hidden;

					img {
						width: 100%;
					}
				}

				.product-msg {
					flex: 1;
					margin-left: 20px;

					.name {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 2px;
						line-height: 1;

						.left {
							flex: 1;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							font-size: 16px;
							color: $fontColor;
						}

						.right {
							flex-shrink: 0;
							margin-left: 20px;
							font-size: 16px;
							color: #909399;
						}
					}

					.msg {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						margin-top: 10px;

						.label {
							flex-shrink: 0;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 20px;
							height: 20px;
							border: 1px solid #C0C4CC;
							border-radius: 5px;
							font-size: 13px;
							font-weight: 400;
							color: #909399;
						}

						.val {
							margin-left: 4px;
							line-height: 1.2;
							font-size: 14px;
							font-weight: 400;
							color: #909399;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}
				}
			}

			.tab2,
			.tab3,
			.tab4,
			{
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: 206px;
			font-size: 14px;
		}

		.tab2 {
			flex-direction: column;
		}

		.price {
			font-size: 16px;
		}

		.underline-price {
			font-size: 14px;
			color: #BCBCBC;
			text-decoration: line-through;
		}
	}

	.adress-box {
		margin-top: 10px;
		background: #FFFFFF;
		border-radius: 8px;
		width: 100%;
		display: flex;

		.adress-left-box {
			flex: 1;
			width: 740px;
			border-right: 1px dotted #EDEFF2;
			padding: 30px 20px;
			box-sizing: border-box;

			.adress-line {
				display: flex;
				align-items: center;
				margin-bottom: 30px;
				line-height: 1;

				.line-left {
					width: 100px;
					font-size: 14px;
					font-weight: 400;
					color: #909399;
					flex-shrink: 0;
				}

				.line-right {
					font-size: 15px;
					font-weight: 400;
					color: #262728;
				}
			}
		}

		.adress-right-box {
			width: 458px;
			flex-shrink: 0;
			padding: 30px;
			box-sizing: border-box;

			.amount-box {
				padding-top: 20px;
				border-top: 1px #EDEFF2 solid;
			}

			.right-line:last-child {
				margin-bottom: 0;
			}

			.right-line {
				display: flex;
				justify-content: space-between;
				line-height: 1;
				margin-bottom: 24px;

				.line-text {
					font-size: 14px;
					font-weight: 400;
					color: #909399;
				}

				.line-num {
					font-size: 15px;
					font-weight: 400;
					color: #262728;
				}
			}
		}
	}

	.status-box {
		min-height: 306px;
		background: #FFFFFF;
		border-radius: 8px;
		width: 100%;

		.header-line {
			display: flex;
			justify-content: space-between;
			padding: 20px;
			border-bottom: 1px solid #EDEFF2;
			line-height: 1;
			font-size: 14px;
			font-weight: 400;
			color: #262728;

			.header-line-left {
				span {
					margin-right: 40px;
				}

				span:last-child {
					margin-right: 0 !important;
				}
			}
		}

		.status-content {
			display: flex;
			align-items: baseline;
		}

		.left-box {
			flex: 1;
			width: 740px;
			border-right: 1px dotted #EDEFF2;
			padding: 26px 20px 28px;
			box-sizing: border-box;

			.logistics-box {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;

				.logistics-scroll-x {
					width: 455px;


					.logistics-single:last-child {
						margin-right: 0;
					}

					.logistics-single {
						margin-right: 20px;
						margin-bottom: 20px;
						height: 40px;
						line-height: 40px;
						background: #EDEFF2;
						opacity: 0.8;
						border-radius: 10px;
						padding: 0 18px;
						box-sizing: border-box;
						font-size: 16px;
						font-weight: 500;
						color: #262728;
						display: inline-flex;
						overflow: hidden;

					}

					.select {
						background: #FCF4C3;
						border: 1px solid #F4DE5D;
						position: relative;
					}

					.select::after {
						content: '';
						position: absolute;
						bottom: -6px;
						right: -10px;
						width: 24px;
						height: 24px;
						background: #F4DE5D;
						border-radius: 50%;
					}

					.icon {
						position: absolute;
						bottom: 8px;
						right: 2px;
						color: #262728;
						width: 12px;
						height: 8px;
						z-index: 100;
						font-weight: bold;
					}

					.icon-duihao {
						position: absolute;
						bottom: -12px;
						right: 2px;
						color: #262728;
						font-size: 6px !important;
						z-index: 100;
					}
				}

				.logistics-right {
					font-size: 16px;
					color: #262728;

					.logistics-right-text {
						font-weight: bold;
					}

					.logistics-right-num {
						font-weight: 400;
						margin-left: 16px;
					}

					.iconfont {
						margin-left: 6px;
						color: #909399;
						font-size: 14px;
					}
				}
			}

			.logistics-info-box {
				display: flex;
				flex-direction: column;
				width: 702px;
				background: #EDEFF2;
				opacity: 0.5;
				border-radius: 10px;
				padding: 16px 24px 16px 14px;
				box-sizing: border-box;

				.info-left-self {
					font-size: 14px;
					font-weight: bold;
					color: #262728;
				}

				.info-left:last-child {
					margin-bottom: 0;
				}

				.info-left {
					margin-bottom: 16px;
					display: flex;

					.left-icon {
						text-align: center;
						line-height: 20px;
						width: 20px;
						height: 20px;
						background: #C0C4CC;
						border-radius: 50%;
						flex-shrink: 0;

						.icon-shangpinfahuo {
							color: #FFFFFF;
							font-size: 12px;
						}
					}

					.left-text {
						margin-left: 8px;

						.left-text-line {
							font-size: 14px;
							font-weight: bold;
							color: #262728;
						}

						.left-text-subline {
							margin-top: 8px;
							font-size: 14px;
							font-weight: 400;
							color: #606366
						}
					}
				}

				.info-right {
					font-size: 14px;
					font-weight: 400;
					color: #005EB1;
					display: flex;
					justify-content: center;
				}
			}

		}

		.right-box {
			flex-shrink: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			padding: 48px 0;

			.status-text {
				font-size: 22px;
				font-weight: bold;
				color: #262728;

				.iconfont {
					font-size: 22px;
					margin-right: 8px;
				}
			}

			.status-subtext {
				margin-top: 16px;
				font-size: 14px;
				font-weight: 400;
				color: #909399;
			}

			.btn-box {
				margin-top: 50px;
				display: flex;

				.el-button--primary {
					width: 103px;
					height: 42px;
					border-radius: 8px;
					font-size: 16px;
				}

				.is-plain {
					width: 103px;
					height: 42px;
					border-radius: 8px;
					font-size: 16px;
				}
			}
		}
	}

	.el-tabs {
		.el-tabs__header {
			margin: 0 0 10px;
			padding-left: 20px;
			height: 60px;
			background: #FFFFFF;
			border-radius: 8px;

			.el-tabs__nav-wrap::after {
				content: none;
			}

			.el-tabs__item {
				position: relative;
				padding: 0 30px;
				height: 60px;
				line-height: 60px;
				color: $fontColor;

				.tag {
					position: absolute;
					top: 15px;
					left: 75px;
					padding: 0 6px;
					height: 16px;
					line-height: 16px;
					background: #F43232;
					border-radius: 8px;
					font-size: 13px;
					font-weight: 400;
					color: #FFFFFF;
				}
			}

			.is-top:nth-child(2) {
				padding-left: 0 !important;
			}

			.is-active {
				font-weight: bold;
			}
		}
	}

	.warning-box {
		width: 307px;
		background: #FFFFFF;
		border-radius: 15px;
		margin: 0 auto;
		box-sizing: border-box;
		padding: 20px 29px;
		padding-top: 0;

		.title {
			margin: 0 auto;
			text-align: center;
			font-size: 17px;
			font-weight: bold;
			color: #000000;
		}

		.btn {
			width: 100%;
			background: #FFCC00;
			line-height: 40px;
			text-align: center;
			color: #262728;
			font-size: 15px;
			font-weight: bold;
			border-radius: 23px;
		}

		.warning-list {
			margin: 0 0 30px;
			width: 100%;
			font-size: 13px;
			font-weight: 500;
			color: #606366;

			.li {
				margin-bottom: 5px;
			}
		}
	}
	}
</style>